/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PatientResponsibilityBreakdown } from "./PatientResponsibilityBreakdown";

/**
 * Eligibility and patient responsibility for one Bridge service type
 */
export interface ServiceEligibilityResult {
  service_type_id: string;
  /** Bridge status: ELIGIBLE, UNINSURED, INELIGIBLE, INEFFECTIVE */
  status: string;
  eligible: boolean;
  /** Total patient responsibility in cents, if available */
  patient_responsibility?: number | null;
  breakdown?: PatientResponsibilityBreakdown | null;
  /** Number of available providers for this service type */
  provider_count?: number;
}
